import React, { Component, Fragment } from 'react';
import { Table, Card, Avatar } from 'antd';
import { inject, observer } from 'mobx-react/index';

@inject('store')
@observer
export class BalancesView extends Component {
    static schema = [
        {
            title: 'Coin',
            dataIndex: 'id',
            key: 'id',
            sorter: (a, b) => {
                if (a.id < b.id) return -1;
                if (a.id > b.id) return 1;
                return 0;
            },
            render: text => {
                return (
                    <Fragment>
                        <Avatar src={`/symbols/${text}.png`} />
                        &nbsp; {text}
                    </Fragment>
                );
            }
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            sorter: (a, b) => {
                if (a.total < b.total) return -1;
                if (a.total > b.total) return 1;
                return 0;
            },
            render: text => text.toFixed(8)
        },
        {
            title: 'Available',
            dataIndex: 'free',
            key: 'free',
            sorter: (a, b) => {
                if (a.free < b.free) return -1;
                if (a.free > b.free) return 1;
                return 0;
            },
            render: text => (text ? text.toFixed(8) : 0)
        },
        {
            title: 'On Order',
            dataIndex: 'used',
            key: 'used',
            sorter: (a, b) => {
                if (a.used < b.used) return -1;
                if (a.used > b.used) return 1;
                return 0;
            },
            render: text => (text ? text.toFixed(8) : 0)
        },
        {
            title: `BTC Value / Base Value`,
            dataIndex: 'btc_value',
            key: 'btc_value',
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                if (a.btc_value < b.btc_value) return -1;
                if (a.btc_value > b.btc_value) return 1;
                return 0;
            },
            render: (text, o) => {
                if (o.base_value)
                    return `${text.toFixed(8)} BTC / ${o.base_value.toFixed(8)} ${o.base}`;
                return `${text.toFixed(8)} BTC`;
            }
        },
        {
            title: `$ Value`,
            dataIndex: 'dollar_value',
            key: 'dollar_value',
            render: text => `$${text.toFixed(2)}`
        }
    ];

    componentDidMount() {
        this.props.store.botStore.balanceStore.getBalances();
    }

    render() {
        const balances = this.props.store.botStore.balanceStore.balances;
        const prices = this.props.store.botStore.tickersStore.tickers;
        const botConfig = this.props.store.botStore.currentConfiguration;
        const exchangeConfig = this.props.store.exchangeConfig[
            this.props.store.botStore.currentConfiguration.exchange
        ];
        if (!prices) return null;

        //ENH: have an uniform way of getting BTC price
        const btcDollar = prices[`BTC/USDT`] || prices['BTC/USD'];
        if (!btcDollar) return null;

        const augmentedBalances = [];
        let btcTotal = 0;
        let baseTotal = null;
        let usdtTotal = 0;
        const baseInfo = prices[`${botConfig.base_currency}/BTC`];

        balances.forEach(asset => {
            const priceInfo = prices[`BTC/${asset.id}`] || prices[`${asset.id}/BTC`];

            if ((priceInfo && asset.total > 0) || asset.id === 'BTC') {
                let btcValue = asset.id === 'BTC' ? asset.total : asset.total * priceInfo.last;
                if (exchangeConfig.tether_coins.indexOf(asset.id) >= 0) {
                    btcValue = asset.total / priceInfo.last;
                }
                const usdValue = btcValue * btcDollar.last;

                btcTotal += btcValue;
                usdtTotal += usdValue;

                if (baseInfo) {
                    baseTotal += btcValue / baseInfo.last;
                }

                augmentedBalances.push({
                    ...asset,
                    btc_value: btcValue,
                    dollar_value: btcValue * btcDollar.last,
                    base: baseInfo ? baseInfo.symbol.replace('BTC', '').replace('-', '') : '',
                    base_value: baseInfo ? btcValue / baseInfo.last : null
                });
            }
        });

        return (
            <Fragment>
                <Card
                    bordered={false}
                    title={`Balances`}
                    extra={`Estimated Value: ${btcTotal.toFixed(8)} BTC / ${`${
                        baseTotal ? `${baseTotal.toFixed(8)} ${botConfig.base_currency} /` : ''
                    }`} $${usdtTotal.toFixed(2)}`}
                >
                    <Table
                        size="small"
                        scroll={{ x: 1000 }}
                        dataSource={augmentedBalances}
                        rowKey="id"
                        pagination={{
                            showSizeChanger: true,
                            pageSize: 100,
                            pageSizeOptions: ['10', '25', '50', '100']
                        }}
                        columns={BalancesView.schema}
                    />
                </Card>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/BalancesView/index.js